module.exports = __webpack_public_path__ + "img/prot-700.6099e09b.png";